import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-facility-add-location",
	templateUrl: "./facility-add-location.component.html",
	styleUrls: ["./facility-add-location.component.css"],
})
export class FacilityAddLocationComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.lstLocations = this.dialogConfig.data.lstLocations;
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////
	lstLocations: any = [];
	Code: any = "";
	Name: any = "";
	errorMessage: any = "";
	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == "") {
			this.errorMessage = "Enter a Location Code";
			return;
		}
		if (this.Name == "") {
			this.errorMessage = "Enter a Location Name";
			return;
		}

		for (var i = 0; i < this.lstLocations.length; i++) {
			var next = this.lstLocations[i];
			if (next.FacilityLocationCD == this.Code) {
				this.errorMessage = "Location Code Already Taken";
				return;
			}
		}

		let myData: any = {
			FacilityLocationCD: this.Code,
			FacilityLocationName: this.Name,
			ActiveDesc: "Active",
		};

		this.ref.close(myData);
	}
	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////
}
